import { render, staticRenderFns } from "./p_footer032.vue?vue&type=template&id=95bee0cc&scoped=true&"
import script from "./p_footer032.vue?vue&type=script&lang=js&"
export * from "./p_footer032.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95bee0cc",
  null
  
)

export default component.exports